import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import Layout from './components/Layout';
import ContactPage from './pages/ContactPage';
import LandingPage from './pages/LandingPage';
import SponsorsPage from './pages/SponsorsPage';
import MarketPage from './pages/MarketPage';
import GamesPage from './pages/GamesPage';
import BlackjackPage from './pages/BlackjackPage';
import MinesPage from './pages/MinesPage';
import LimboPage from './pages/LimboPage';
import MoonPage from './pages/MoonPage';
import TicketsPage from './pages/TicketsPage';
import PromoCodePage from './pages/PromoCodePage';
import ProfilePage from './pages/ProfilePage';
import SettingsPage from './pages/SettingsPage';
import SpinEventPage from './pages/SpinEventPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Register from './pages/Register';
import UserLogin from './pages/UserLogin';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ProtectedRoute from './components/ProtectedRoute';
import LightEffects from './components/LightEffects';
import Popup from './components/Popup';

function App() {
  return (
    <Router>
      <Analytics />
      <LightEffects />
      <Popup />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<LandingPage />} />
          <Route path="sponsors" element={<SponsorsPage />} />
          <Route path="market" element={<MarketPage />} />
          <Route path="games" element={<GamesPage />} />
          <Route path="games/blackjack" element={<BlackjackPage />} />
          <Route path="games/mines" element={<MinesPage />} />
          <Route path="games/limbo" element={<LimboPage />} />
          <Route path="moon" element={<MoonPage />} />
          <Route path="tickets" element={<TicketsPage />} />
          <Route path="promo-code" element={<PromoCodePage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="spin-event" element={<SpinEventPage />} />
          <Route path="spin-event/:year/:month" element={<SpinEventPage />} />
        </Route>
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<UserLogin />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/*" element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;
